import type { Room } from '@hollowveil/shared';

export const roomVillageHouse: Room = {
      id: 'room_village_house',
      name: "Aelindra's Home",
      description:
        'A cozy village home. Since touching the ancient relic, you can see things others cannot...',
      size: [18, 10, 18],
      floorStyle: 'wood',
      ambiance: {
        realWorld: {
          backgroundColor: '#FDF6F0',
          ambientLightColor: '#FFF5E6',
          ambientLightIntensity: 0.6,
        },
        spectralWorld: {
          backgroundColor: '#1C2833',
          ambientLightColor: '#4A6B8A',
          ambientLightIntensity: 0.3,
        },
      },
      objects: [
        // === ZONE SUD - Chambre (entrée) ===
        {
          id: 'obj_bed',
          name: 'Lit',
          type: 'static',
          modelId: 'block',
          position: [3, 0, 3],
          rotation: [0, 0, 0],
          scale: [2.5, 0.6, 1.5],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { variant: 'wood' },
        },
        // === ZONE CENTRE-OUEST - Coin repas ===
        {
          id: 'obj_table',
          name: 'Table',
          type: 'interactive',
          modelId: 'block',
          position: [4, 0, 8],
          rotation: [0, 0, 0],
          scale: [2, 0.8, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { variant: 'wood' },
          onInteract: [
            {
              type: 'showMessage',
              params: {
                message:
                  'Une vieille table en bois. Dans l\'autre monde, une lueur semble émaner de dessous...',
              },
            },
          ],
        },
        // Crystal sur la table
        {
          id: 'obj_crystal',
          name: 'Cristal Mystérieux',
          type: 'interactive',
          modelId: 'crystal',
          position: [4, 0.85, 8],
          rotation: [0, 0, 0],
          scale: [0.8, 0.8, 0.8],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
          onInteract: [
            {
              type: 'addToInventory',
              params: {
                itemId: 'mysterious_crystal',
                itemName: 'Cristal Mystérieux',
                itemDescription: 'Un cristal qui vibre d\'une énergie ancienne. Il résonne avec la relique.',
                itemIcon: 'crystal',
              },
            },
            {
              type: 'showMessage',
              params: {
                message: 'Tu récupères le Cristal Mystérieux ! Il vibre d\'une énergie ancienne...',
              },
            },
            {
              type: 'hideObject',
              params: {
                objectId: 'obj_crystal',
              },
            },
          ],
        },
        // === ZONE EST - Stockage ===
        {
          id: 'obj_chest',
          name: 'Vieux Coffre',
          type: 'interactive',
          modelId: 'chest',
          position: [14, 0, 4],
          rotation: [0, -Math.PI / 4, 0],
          scale: [1.2, 1.2, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'real',
          properties: {},
          onInteract: [
            {
              type: 'openDoorWithItem',
              params: {
                doorId: 'obj_chest',
                requiredItemId: 'spectral_key',
              },
            },
          ],
        },
        // === PILIERS - Structure de la maison ===
        {
          id: 'obj_pillar_1',
          name: 'Pilier de Pierre',
          type: 'static',
          modelId: 'pillar',
          position: [2, 0, 12],
          rotation: [0, 0, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { height: 4 },
        },
        {
          id: 'obj_pillar_2',
          name: 'Pilier de Pierre',
          type: 'static',
          modelId: 'pillar',
          position: [15, 0, 12],
          rotation: [0, 0, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { height: 4 },
        },
        // === ZONE NORD - Sortie ===
        {
          id: 'obj_arch',
          name: 'Porte de Sortie',
          type: 'interactive',
          modelId: 'arch',
          position: [9, 0, 15],
          rotation: [0, 0, 0],
          scale: [1.2, 1.2, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
          onInteract: [
            {
              type: 'showMessage',
              params: {
                message:
                  'Cette porte mène dehors. Mais d\'abord, tu devrais explorer la présence étrange que tu ressens...',
              },
            },
          ],
        },
        // === OBJETS DU MONDE SPECTRAL ===
        // Clé cachée dans un coin obscur
        {
          id: 'obj_spectral_key',
          name: 'Clé Spectrale',
          type: 'interactive',
          modelId: 'spectral_key',
          position: [15, 0.5, 2],
          rotation: [0, 0, 0],
          scale: [1.5, 1.5, 1.5],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
          onInteract: [
            {
              type: 'addToInventory',
              params: {
                itemId: 'spectral_key',
                itemName: 'Clé Spectrale',
                itemDescription: 'Une clé éthérée qui brille d\'une lueur fantomatique.',
                itemIcon: 'key',
              },
            },
            {
              type: 'showMessage',
              params: {
                message: 'Tu as trouvé une Clé Spectrale ! Elle peut ouvrir des portes dans le monde réel...',
              },
            },
            {
              type: 'hideObject',
              params: {
                objectId: 'obj_spectral_key',
              },
            },
          ],
        },
        // Fantôme au centre de la pièce (flottant)
        {
          id: 'obj_ghost',
          name: 'Vestige Spectral',
          type: 'interactive',
          modelId: 'spectral_remnant',
          position: [9, 0.3, 9],
          rotation: [0, Math.PI, 0],
          scale: [1.3, 1.3, 1.3],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
          onInteract: [
            {
              type: 'showRiddle',
              params: {
                riddle: {
                  id: 'riddle_ghost_color',
                  npcId: 'obj_ghost',
                  npcName: 'Vestige Spectral',
                  question: '"Enfant... tu peux nous voir ?\nLe Voile s\'amincit...\n\nProuve que tu mérites notre confiance.\nRéponds à ceci :\n\nJe suis la couleur de l\'espoir et de la nature,\nMais aussi de l\'envie et du poison.\nQuelle couleur suis-je ?"',
                  hint: 'Pense aux feuilles des arbres, à l\'herbe des prairies...',
                  type: 'text_input',
                  expectedAnswers: ['vert', 'verte', 'green', 'le vert'],
                  correctResponse: '"Oui... le vert... la couleur de la vie et de la mort mêlées. Tu es digne de confiance, jeune voyageur. L\'Ancien t\'attend dans les ruines..."',
                  incorrectResponse: '"Non... ce n\'est pas cela. Réfléchis encore, enfant..."',
                  canRetry: true,
                },
              },
            },
          ],
        },
        // Symbole mystique près du lit
        {
          id: 'obj_spectral_mark',
          name: 'Symbole Ancien',
          type: 'interactive',
          modelId: 'block',
          position: [3, 0.01, 5],
          rotation: [0, 0, 0],
          scale: [1.5, 0.02, 1.5],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: { variant: 'highlight' },
          onInteract: [
            {
              type: 'showMessage',
              params: {
                message:
                  'Un ancien sceau tracé au sol. Il semble protéger la maison de quelque chose...',
              },
            },
          ],
        },
        // Switch for puzzle
        {
          id: 'obj_switch_1',
          name: 'Ancient Switch',
          type: 'trigger',
          modelId: 'switch',
          position: [3, 0, 5],
          rotation: [0, 0, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
          onInteract: [
            {
              type: 'showMessage',
              params: {
                message: 'Click! The switch activates something...',
              },
            },
          ],
        },
        // Vegetation decorations
        {
          id: 'obj_plant_1',
          name: 'Potted Plant',
          type: 'static',
          modelId: 'plant',
          position: [1, 0, 1],
          rotation: [0, 0.5, 0],
          scale: [1.2, 1.2, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_rocks_corner',
          name: 'Decorative Rocks',
          type: 'static',
          modelId: 'rocks',
          position: [9, 0, 1],
          rotation: [0, 0.3, 0],
          scale: [0.8, 0.8, 0.8],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_flower_window',
          name: 'Window Flower',
          type: 'static',
          modelId: 'flower',
          position: [0.5, 0, 5],
          rotation: [0, 0.8, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // === PLATFORM TEST AREA ===
        // Platform 1 - Low step
        {
          id: 'obj_platform_1',
          name: 'Petite Estrade',
          type: 'static',
          modelId: 'platform',
          position: [7, 0, 7],
          rotation: [0, 0, 0],
          scale: [2, 0.3, 2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { walkable: true },
        },
        // Platform 2 - Medium height
        {
          id: 'obj_platform_2',
          name: 'Estrade Moyenne',
          type: 'static',
          modelId: 'platform',
          position: [7, 0.3, 5],
          rotation: [0, 0, 0],
          scale: [1.5, 0.4, 1.5],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { walkable: true },
        },
        // Stairs connecting levels
        {
          id: 'obj_stairs_1',
          name: 'Escalier',
          type: 'static',
          modelId: 'stairs',
          position: [9, 0, 6],
          rotation: [0, Math.PI / 2, 0],
          scale: [1.2, 0.7, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { walkable: true },
        },
        // ===== DECORATIONS =====
        // Furniture
        {
          id: 'obj_deco_chair_1',
          name: 'Chaise',
          type: 'static',
          modelId: 'chair',
          position: [4, 0, 4],
          rotation: [0, Math.PI / 4, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_deco_bookshelf',
          name: 'Bibliothèque',
          type: 'static',
          modelId: 'bookshelf',
          position: [1, 0, 5],
          rotation: [0, Math.PI / 2, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_deco_rug',
          name: 'Tapis',
          type: 'static',
          modelId: 'rug',
          position: [5, 0, 5],
          rotation: [0, 0.2, 0],
          scale: [2, 1, 1.5],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Lighting
        {
          id: 'obj_deco_candles_1',
          name: 'Bougies',
          type: 'static',
          modelId: 'candles',
          position: [5, 0.8, 3.2],
          rotation: [0, 0, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_deco_lantern_1',
          name: 'Lanterne',
          type: 'static',
          modelId: 'lantern',
          position: [1.5, 1.5, 2],
          rotation: [0, 0, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Storage
        {
          id: 'obj_deco_barrel_1',
          name: 'Tonneau',
          type: 'static',
          modelId: 'barrel',
          position: [14, 0, 3],
          rotation: [0, 0.5, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_deco_barrel_2',
          name: 'Tonneau',
          type: 'static',
          modelId: 'barrel',
          position: [15, 0, 2.5],
          rotation: [0, -0.3, 0],
          scale: [0.9, 1.1, 0.9],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_deco_crate_1',
          name: 'Caisse',
          type: 'static',
          modelId: 'crate',
          position: [13, 0, 2],
          rotation: [0, 0.2, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_deco_pot_1',
          name: 'Pot',
          type: 'static',
          modelId: 'pot',
          position: [16, 0, 5],
          rotation: [0, 0, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Far corner decorations
        {
          id: 'obj_deco_table_2',
          name: 'Petite Table',
          type: 'static',
          modelId: 'table',
          position: [14, 0, 14],
          rotation: [0, Math.PI / 6, 0],
          scale: [0.8, 0.8, 0.8],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_deco_chair_2',
          name: 'Chaise',
          type: 'static',
          modelId: 'chair',
          position: [15.5, 0, 14],
          rotation: [0, -Math.PI / 3, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_deco_torch',
          name: 'Torche',
          type: 'static',
          modelId: 'torch_stand',
          position: [16, 0, 10],
          rotation: [0, 0, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Spectral world only decorations
        {
          id: 'obj_deco_cauldron',
          name: 'Chaudron Mystique',
          type: 'static',
          modelId: 'cauldron',
          position: [3, 0, 15],
          rotation: [0, 0, 0],
          scale: [1.2, 1.2, 1.2],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        // === GRAINE ANCIENNE - Objet cross-level pour le niveau 2 ===
        {
          id: 'obj_ancient_seed',
          name: 'Graine Ancienne',
          type: 'interactive',
          modelId: 'ancient_seed',
          position: [5, 0, 13],
          rotation: [0, 0, 0],
          scale: [2, 2, 2],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
          onInteract: [
            {
              type: 'addToInventory',
              params: {
                itemId: 'ancient_seed',
                itemName: 'Graine Ancienne',
                itemDescription: 'Une graine brillante d\'énergie spirituelle. L\'Esprit de l\'Arbre Ancien pourrait en avoir besoin...',
                itemIcon: 'flower',
              },
            },
            {
              type: 'showMessage',
              params: {
                message: 'Tu récupères la Graine Ancienne ! Elle pulse d\'une énergie mystique...',
              },
            },
            {
              type: 'hideObject',
              params: {
                objectId: 'obj_ancient_seed',
              },
            },
          ],
        },
        {
          id: 'obj_deco_candles_spectral',
          name: 'Bougies Spectrales',
          type: 'static',
          modelId: 'candles',
          position: [2, 0, 14],
          rotation: [0, 0, 0],
          scale: [1.5, 1.5, 1.5],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        // Mirror (spectral reveals secrets)
        {
          id: 'obj_deco_mirror',
          name: 'Miroir Ancien',
          type: 'static',
          modelId: 'mirror',
          position: [1, 0, 12],
          rotation: [0, Math.PI / 2, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
      ],
      puzzles: [
        {
          id: 'puzzle_first_key',
          name: 'The Hidden Key',
          type: 'worldBridge',
          state: 'active',
          description: 'Find the key hidden in the spectral world to unlock the chest.',
          hint: 'Look beneath where you cannot normally see...',
          linkedObjectIds: ['obj_spectral_key', 'obj_chest'],
          solution: {
            type: 'items',
            expected: ['spectral_key'],
          },
          onSolve: [
            {
              type: 'showMessage',
              params: {
                message: 'The chest opens, revealing an old map!',
              },
            },
            {
              type: 'unlockDoor',
              params: { doorId: 'obj_arch' },
            },
          ],
        },
      ],
      connections: [
        {
          targetRoomId: 'room_forest_garden',
          position: [9, 0, 16],
          direction: 'north',
          locked: false,
        },
      ],
      initialWorld: 'real',
      hasSpectralLayer: true,
      palette: 'sunset',
      biome: 'forest',
      weather: 'none',
      weatherIntensity: 0,
      npcs: [
        // === ANIMAUX DU MONDE RÉEL ===
        {
          id: 'npc_squirrel_1',
          type: 'squirrel',
          name: 'Écureuil Curieux',
          position: [5, 0, 2],
          scale: 2.5,
          idleAnimation: 'sit',
          petAnimation: 'jump',
          petRadius: 2,
          petCooldown: 2000,
          isPettable: true,
          visibleInWorld: 'real',
        },
        {
          id: 'npc_bird_1',
          type: 'bird',
          name: 'Petit Oiseau',
          position: [12, 1.5, 7],
          scale: 2.5,
          idleAnimation: 'fly',
          petAnimation: 'chirp',
          petRadius: 2,
          petCooldown: 2000,
          isPettable: true,
          visibleInWorld: 'real',
        },
        // === ANIMAUX DU MONDE SPECTRAL (versions mystérieuses) ===
        {
          id: 'npc_hedgehog_1',
          type: 'hedgehog',
          name: 'Hérisson Fantôme',
          position: [2, 0, 14],
          scale: 2.5,
          idleAnimation: 'sleep',
          petAnimation: 'happy',
          petRadius: 2,
          petCooldown: 2500,
          isPettable: true,
          visibleInWorld: 'spectral',
        },
        {
          id: 'npc_fox_1',
          type: 'fox',
          name: 'Renard du Voile',
          position: [14, 0, 14],
          scale: 2.5,
          idleAnimation: 'sit',
          petAnimation: 'nuzzle',
          petRadius: 2.5,
          petCooldown: 3000,
          isPettable: true,
          visibleInWorld: 'spectral',
        },
      ],
    };
